// extracted by mini-css-extract-plugin
export default {"WhiteLabeled":"vIjT78TI","WhiteLabeledIcon":"TLByz9k1"};